import { render, staticRenderFns } from "./biometric_disclosure.vue?vue&type=template&id=17e7a6b0&"
import script from "./biometric_disclosure.vue?vue&type=script&lang=js&"
export * from "./biometric_disclosure.vue?vue&type=script&lang=js&"
import style0 from "./biometric_disclosure.vue?vue&type=style&index=0&id=17e7a6b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports